<template>
    <b-container>
        <strong class="text-primary">Auf dem Gerät</strong>
        <div v-for="sheet in savedSheets" :key="sheet" @click="viewPDF(sheet)">
            <el-card class="clickable d-flex align-items-center mb-1 document-entry">
                <i class="el-input__icon el-icon-document mr-1"></i>{{ sheet }}
            </el-card>
        </div>
        <el-divider></el-divider>
        <strong class="text-primary">In der Cloud</strong>
        <el-card
            v-for="sheet in cloudSheets"
            :key="sheet"
            class="clickable d-flex align-items-center mb-1 document-entry"
            variant="secondary"
        >
            <i class="el-input__icon el-icon-cloudy mr-1"></i>{{ sheet }}
        </el-card>
        <hr />
        <el-button round class="login-button" @click="showLogout">Ausloggen</el-button>

        <el-dialog
            title="Ausloggen"
            :visible.sync="dialogVisible"
            width="80%"
            style="max-width: 600px; margin: 0 auto;"
        >
            <span>Möchten Sie sich wirklich ausloggen?</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">Abbrechen</el-button>
                <el-button type="primary" @click="logout">Jetzt ausloggen</el-button>
            </span>
        </el-dialog>
    </b-container>
</template>

<script>
export default {
    name: 'Dokumente',
    components: {},
    props: {},
    data() {
        return {
            savedSheets: ['Kachelverband Handbuch 2019', 'Kachelverband Cheatsheet', 'Kachelverband Super Buch'],
            cloudSheets: ['Kachelverband Handbuch 2020'],
            dialogVisible: false,
        };
    },
    computed: {},
    mounted() {},
    methods: {
        viewPDF() {
            this.$router.push('/view');
        },
        showLogout() {
            this.dialogVisible = true;
        },
        logout() {
            this.$parse.User.logOut().then(() => {
                this.dialogVisible = false;
                window.location.reload();
            });
        },
    },
};
</script>
